export const FINALLY_IMPORT_POLLING_INTERVAL = 10000;

export const FINALLY_REVERT_POLLING_INTERVAL = 5000;

export const FINALLY_REVERT_FAILED_MESSAGE =
  "Couldn't revert the import. Check the accounting lock date and try again.";

export const FINALLY_REVERTED_DATA_TAGS = [
  "CHART_OF_ACCOUNTS",
  "BOOKS_TRANSACTIONS",
  "BOOKS_SINGLE_TRANSACTION",
  "GENERAL_LEDGER",
  "JOURNAL_ENTRIES",
  "REPORTS",
] as const;

export const FINALLY_FILE_ACCEPT = {
  "text/csv": [".csv"],
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
    ".xlsx",
  ],
};

export const FINALLY_JE_ERROR_KEYWORD = "Journal Entries";

export const FINALLY_WHERE_TO_FIND_ITEMS = [
  {
    label: "1. Chart of Accounts:",
    description:
      "Chart of Accounts → Export. The file has the columns Account Name, Account Number, Account Type, Account Detail, Status, Balance",
  },
  {
    label: "2. Journal Entries:",
    description:
      "Journal Entries → Export the full date range you want to import. If the range is split across several exports, upload all of them. Each file has the columns Num, Transaction date, Transaction type, Name, Memo, Full name, Debit, Credit",
  },
];

export const FINALLY_REVERT_CONFIRMATION_TEXT = "REVERT";
